export const COLORS = {
  cerulean: '#009bdf',
  white: '#ffffff',
  naturalGray: '#908c89',
  fiord: '#4d5c6d',
  silverSand: '#bdbfc1',
  athensGray: '#f6f6f7',
  slateGray: '#798993',
  iron: '#e6e6e7',
  sunFlower: '#E6E622',
  red: 'red',
  darkerGray: '#7B7B7B'
};

export const theme = {
  heading: '#071743',
  lightGray: '#E5EBF2',
  footer: '#363636',
  barlow: "'Barlow', sans-serif",
  barlowCondensed: "'Barlow Condensed', sans-serif",
  textGray: '#525252'
};

export const ICONS = {
  ALERT:
    'M 256 8 C 119.043 8 8 119.083 8 256 c 0 136.997 111.043 248 248 248 s 248 -111.003 248 -248 C 504 119.083 392.957 8 256 8 Z m 0 110 c 23.196 0 42 18.804 42 42 s -18.804 42 -42 42 s -42 -18.804 -42 -42 s 18.804 -42 42 -42 Z m 56 254 c 0 6.627 -5.373 12 -12 12 h -88 c -6.627 0 -12 -5.373 -12 -12 v -24 c 0 -6.627 5.373 -12 12 -12 h 12 v -64 h -12 c -6.627 0 -12 -5.373 -12 -12 v -24 c 0 -6.627 5.373 -12 12 -12 h 64 c 6.627 0 12 5.373 12 12 v 100 h 12 c 6.627 0 12 5.373 12 12 v 24 Z',
  ENVELOPE:
    'M 464 64 H 48 C 21.49 64 0 85.49 0 112 v 288 c 0 26.51 21.49 48 48 48 h 416 c 26.51 0 48 -21.49 48 -48 V 112 c 0 -26.51 -21.49 -48 -48 -48 Z m 0 48 v 40.805 c -22.422 18.259 -58.168 46.651 -134.587 106.49 c -16.841 13.247 -50.201 45.072 -73.413 44.701 c -23.208 0.375 -56.579 -31.459 -73.413 -44.701 C 106.18 199.465 70.425 171.067 48 152.805 V 112 h 416 Z M 48 400 V 214.398 c 22.914 18.251 55.409 43.862 104.938 82.646 c 21.857 17.205 60.134 55.186 103.062 54.955 c 42.717 0.231 80.509 -37.199 103.053 -54.947 c 49.528 -38.783 82.032 -64.401 104.947 -82.653 V 400 H 48 Z',
  LOCK:
    'M 400 224 h -24 v -72 C 376 68.2 307.8 0 224 0 S 72 68.2 72 152 v 72 H 48 c -26.5 0 -48 21.5 -48 48 v 192 c 0 26.5 21.5 48 48 48 h 352 c 26.5 0 48 -21.5 48 -48 V 272 c 0 -26.5 -21.5 -48 -48 -48 Z m -104 0 H 152 v -72 c 0 -39.7 32.3 -72 72 -72 s 72 32.3 72 72 v 72 Z',
  CHECK:
    'M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z',
  DEFAULT_USER:
    'M423.309 291.025L402.221 285C431.798 243.89 436 202.294 436 180 436 80.649 355.484 0 256 0 156.649 0 76 80.516 76 180c0 22.299 4.198 63.884 33.779 105l-21.088 6.025C21.28 310.285 0 371.59 0 408.605v25.681C0 477.138 34.862 512 77.714 512h356.571C477.138 512 512 477.138 512 434.286v-25.681c0-36.247-20.725-98.161-88.691-117.58zM256 48c72.902 0 132 59.099 132 132s-59.098 132-132 132-132-59.099-132-132S183.098 48 256 48zm208 386.286c0 16.41-13.304 29.714-29.714 29.714H77.714C61.304 464 48 450.696 48 434.286v-25.681c0-33.167 21.987-62.316 53.878-71.427l46.103-13.172C162.683 335.058 200.427 360 256 360s93.317-24.942 108.019-35.994l46.103 13.172C442.013 346.29 464 375.438 464 408.605v25.681z',
  ARROW_LEFT:
    'M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z',
  X:
    'M323.1 441l53.9-53.9c9.4-9.4 9.4-24.5 0-33.9L279.8 256l97.2-97.2c9.4-9.4 9.4-24.5 0-33.9L323.1 71c-9.4-9.4-24.5-9.4-33.9 0L192 168.2 94.8 71c-9.4-9.4-24.5-9.4-33.9 0L7 124.9c-9.4 9.4-9.4 24.5 0 33.9l97.2 97.2L7 353.2c-9.4 9.4-9.4 24.5 0 33.9L60.9 441c9.4 9.4 24.5 9.4 33.9 0l97.2-97.2 97.2 97.2c9.3 9.3 24.5 9.3 33.9 0z'
};

export const mediaQueries = {
  xs: modifier => `@media (max-width: 576px) {${modifier}}`,
  sm: modifier => `@media (max-width: 768px) {${modifier}}`,
  md: modifier => `@media (max-width: 992px) {${modifier}}`,
  lg: modifier => `@media (max-width: 1200px) {${modifier}}`
};

export const mediaSizes = {
  xs: modifier => `@media (min-width: 393px) {${modifier}}`,
  sm: modifier => `@media (min-width: 768px) {${modifier}}`,
  md: modifier => `@media (min-width: 1024px) {${modifier}}`,
  lg: modifier => `@media (min-width: 1280px) {${modifier}}`
};

export default COLORS;



// WEBPACK FOOTER //
// ./src/utils/styles.js